export interface Vehicle
{
    id: number;
    SourceId: Source;
    BoxId?: string;
    Division: string;
    DivisionId?: number;
    ServiceAccount?: string;
    ServiceAccountId?: number;
    GeotabTitle: string;
    GeotabId: string;
    TimezoneTitle: string;
    TimezoneId: number;
    Display: string;
    Tags: string[];
    LastDataDateTime?: string;
    OngoingAutoImport: boolean;
}

export interface VehicleDraft
{
    id?: number;
    SourceId: Source;
    BoxId?: string;
    Division?: string;
    DivisionId?: number;
    ServiceAccount?: string;
    ServiceAccountId?: number;
    GeotabTitle: string;
    GeotabId: string;
    TimezoneId: string | number;
    Display: string;
    Tags: string[];
}

export enum Source
{
    Geotab = 1,
    BoxId = 2,
}


// WEBPACK FOOTER //
// ./src/models/Vehicle.ts